import { notification } from 'antd'
import { useQueryClient } from 'react-query'
import { useTranslation } from 'react-i18next'

import { DataApi, QUERY_KEYS } from '@api'
import { AxiosErrorType } from '@types'

const useInputHes = () => {
  const { t } = useTranslation()
  const tPreffix = 'suppliers_router.suppliers_dashboard.use_update_driver.'

  const queryClient = useQueryClient()

  const onUpdateSuccess = () => {
    queryClient.invalidateQueries(QUERY_KEYS.BILLING_BATCH)
  }

  const inputHes = async (hes: string, id: number) => {
    try {
      await DataApi.inputHes(hes, id)
      onUpdateSuccess()
      notification.success({
        message: 'Se ingresó el Hes correctamente',
      })
    } catch (error) {
      const axiosError = error as AxiosErrorType

      if (axiosError && axiosError.data && axiosError.data.error) {
        const errorResponse = axiosError.data.error
        const { type, message } = errorResponse

        if (type === 'SOME_ERROR_TYPE') {
          const hint =
            message.length > 62
              ? `${t(`${tPreffix}no_active_route_hint`)} ${message.substring(62)}`
              : `${t(`${tPreffix}no_active_route_at_all_hint`)}`

          notification.error({
            message: `${t(`${tPreffix}no_active_route`)} ${hint}`,
          })
        } else {
          notification.error({
            message: 'Error al ingresa el Hes',
          })
        }
      } else {
        console.error('Error:', axiosError)
      }
    }
  }

  return {
    inputHes,
  }
}

export { useInputHes }
